// extracted by mini-css-extract-plugin
module.exports = {"service_wrapper":"_927a99ad28--service_wrapper--ASI9Z","service_icon":"_927a99ad28--service_icon--cAplZ","service_name":"_927a99ad28--service_name--BUuIS"};